import styled from 'styled-components';
import { colors } from '../../style/colors';
import { H2, SmallP } from '../../style/typography';
import { min } from '../../lib/responsive';

const GetInvolvedPreviewContainer = styled.div`
  display: flex;
  background-color: ${colors.BLUE};
  height: 85rem;

  @media ${min.tabletSm} {
    height: 66em;
  }
  @media ${min.tablet} {
    height: 65em;
  }

  @media ${min.tabletLg} {
    height: 52em;
  }

  @media ${min.desktop} {
    height: 46em;
  }
  @media ${min.desktopLg} {
    height: 44rem;
  }
`;

const GetInvolvedFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  margin: 2em 0;

  @media ${min.tabletSm} {
    margin: 3em 0;
  }

  @media ${min.tabletLg} {
    margin: 3em 0;
    flex-direction: row;
  }
`;

const GetInvolvedFlexText = styled.div`
  flex-direction: column;
  padding-bottom: 1.75em;
`;

const GetInvolvedPreviewHeader = styled(H2)`
  color: ${colors.WHITE};
  margin: 0em;
  line-height: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
`;

const GetInvolvedPreviewText = styled(SmallP)`
  color: ${colors.WHITE};
  padding-bottom: 1.5em;

  @media ${min.tablet} {
    width: 75%;
  }
`;

const GetInvolvedPreviewGridDesktop = styled.img`
  display: none;
  position: relative;
  object-fit: cover;

  @media ${min.tabletLg} {
    display: block;
    width: 100%;
  }
`;

const GetInvolvedPreviewGridMobile = styled.img`
  display: block;
  position: relative;
  width: 100%;
  object-fit: cover;

  @media ${min.tabletLg} {
    display: none;
  }
`;

const GetInvolvedPreviewMic = styled.img`
  width: 14em;
  align-self: center;

  @media ${min.mobile} {
    margin-top: 3em;
  }

  @media ${min.tabletSm} {
    width: 16em;
    margin-top: 1rem;
  }

  @media ${min.tablet} {
    width: 18em;
    margin-top: 0;
  }

  @media ${min.tabletLg} {
    width: 20em;
    margin-top: 0;
    margin-right: 4em;
  }

  @media ${min.desktop} {
    width: 22em;
  }

  @media ${min.desktopLg} {
    width: 24em;
    margin-right: 8em;
  }
`;

export {
  GetInvolvedPreviewContainer,
  GetInvolvedPreviewHeader,
  GetInvolvedPreviewText,
  GetInvolvedFlexText,
  GetInvolvedPreviewGridDesktop,
  GetInvolvedPreviewGridMobile,
  GetInvolvedPreviewMic,
  GetInvolvedFlexContainer,
};
